// A short quiet period is not proof that a virtualized conversation has loaded.
// Only release its opening pin once the current tail exists and is measured.
export function isChatHistoryPositionReady(element, { targetIds = [], refreshing = false } = {}) {
  if (refreshing || !element?.isConnected || !(element.clientHeight > 0) || !targetIds.length) return false;
  const row = Array.from(element.querySelectorAll('[id^="msg-hl-"]'))
    .find(node => targetIds.some(id => node.id === `msg-hl-${id}`));
  if (!row || !(row.getBoundingClientRect().height > 0)) return false;
  // Images can finish without a message update. Failed loads count as complete.
  if (Array.from(element.querySelectorAll('img')).some(img => !img.complete)) return false;
  const maxOffset = Math.max(0, element.scrollHeight - element.clientHeight);
  return Math.abs(element.scrollTop - maxOffset) <= 2;
}
